<template>
  <!-- index.vue -->
  <v-app
    :style="{
      background: $vuetify.theme.themes[theme].background,
      color: $vuetify.theme.themes[theme].color,
    }"
    class="app-admin-wrap-layout-6"
  >
    <div
      class="loader"
      :class="isAvailableToContentView ? 'sub-loader': ''"
      v-if="loading"
    >
      <div class="logo">
        <img src="@/assets/images/logos/boundless-logo.png" height="35" style="background: #2b2f44; border-radius: 50%;" />
      </div>
      <div class="mt-3 primary--text" v-if="isAvailableToContentView">
        {{ loadingSpinnerText }}
      </div>
    </div>
    <Header></Header>
    <side-bar :themeName="themeName" :is-demo="themeName === 'demo'">
      <!-- -->
    </side-bar>
    <base-view v-if="isAvailableToContentView" />
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
    >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="danger"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { themeData } from '@/data/theme'

export default {
  components: {
    SideBar: () => import("./Sidebar"),
    BaseView: () => import("./View"),
    Header: () => import("./Header.vue"),
  },
  computed: {
    ...mapGetters(["getThemeMode", "loading", "loadingSpinnerText", "snackbarMessage"]),

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  watch:{
    snackbarMessage(newValue){
      if (!newValue) {
        return
      }

      this.snackbar = true
      this.message = newValue
    },

    snackbar(value) {
      if (!value) {
        this.setSnackbarMessage('')
      }
    }
  },

  data() {
    return {
      isAvailableToContentView: false,
      themeName: '',
      snackbar : false,
      message: ''
    }
  },
  async mounted() {
    localStorage.removeItem('theme')
    const path = window.location.pathname

    const detected_theme = this.$route.params.customer
    const valid_themes = ['uber', 'ihg', 'demo']
    
    this.themeName =  valid_themes.includes(detected_theme) ? detected_theme : 'default'

    if (themeData[this.themeName]) {
      this.$vuetify.theme.themes.light = themeData[this.themeName]
    } else {
      this.$vuetify.theme.themes.light = themeData['default']
      this.themeName = 'default'
    }

    localStorage.setItem('theme', this.themeName)
    this.isAvailableToContentView = true
  },
  methods: {
     ...mapActions([
      'setSnackbarMessage',
    ]),
  },
};
</script>
<style lang="scss">
.app-admin-wrap-layout-6 {
  .sidebar-six {
    &.theme--dark.v-navigation-drawer {
      background-color: #111827;
      // background-color: #111827;
    }

    // .top-toolbar {
    //   background-color: #111827;
    // }
  }

  .loader {
    z-index: 99999;

    &.sub-loader {
      background-color: #242939cc;
      display: flex;
      flex-direction: column;
    }
  }
}
div.theme--dark .v-navigation-drawer {
  background-color: #272727 !important;
}
</style>
